import React from 'react';
import { FaRocket } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer id="kontakt" className="bg-black border-t border-gray-800 py-6">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Logo i opis */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="/src/assets/logo.jpg"
                alt="Eagle AI Logo"
                className="w-10 h-10 rounded-lg object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="w-10 h-10 bg-blue-600 rounded-lg items-center justify-center hidden">
                <FaRocket className="text-white text-xl" />
              </div>
              <span className="text-xl font-bold">EAGLE AI AUTOMATIZACIJA</span>
            </div>
            <p className="text-gray-300 mb-4">
              Specijalizovana AI rešenja za e-commerce prodavnice u Srbiji. Automatizujte svoj inbox, povećajte prodaju i uštedite vreme.
            </p>
          </div>

          {/* Kontakt informacije */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
            <div className="space-y-3">
              <div className="text-gray-300 break-all">office@eagleaiagents.com</div>
              <div className="text-gray-300">+381 69 687901</div>
            </div>
          </div>

          {/* Linkovi */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Linkovi</h3>
            <div className="space-y-2">
              <a href="#problem" className="block text-gray-300 hover:text-white transition-colors">Problem</a>
              <a href="#ponuda" className="block text-gray-300 hover:text-white transition-colors">Ponuda</a>
              <a href="#proces" className="block text-gray-300 hover:text-white transition-colors">Proces</a>
              <a href="#kontakt" className="block text-gray-300 hover:text-white transition-colors">Kontakt</a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-4 pt-4 text-center">
          <p className="text-gray-400">
            © 2025 Eagle AI Automatizacija. Sva prava zadržana.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;